import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-5 flex flex-col flex-grow gap-2" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "w-full flex gap-2" }
const _hoisted_7 = { key: 0 }

import {defineComponent, onMounted, ref} from 'vue'
import {query} from "@/graphql";
import TRProgress from "@/components/Base/v2/TRProgress.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'PrimaryProductExport',
  setup(__props) {

const projectId = ref<number>(0);
const magazineId = ref<number>(0);
const purchaserId = ref<number>(0);
const purchasers = ref([]);
const progress = ref<number>(0);
const isLoading = ref<boolean>(false);
const selectedPurchasers = ref<number[]>([0]);
const foodPurchasers = ref(false)
const nonFoodPurchasers = ref(false)

async function getPurchasers() {
  const [data, err] = await query.getPurchasers();
  purchasers.value = data;
  if (err) {
    console.error(err);
    return;
  }
}

function selectPurchasers(type) {
  if (type === 'food') {
    foodPurchasers.value = true;
    nonFoodPurchasers.value = false;
    selectedPurchasers.value = [
      69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79,
      83, 84,
      1727, 1728, 1729, 1730, 1731, 1732, 1733, 1734, 1735, 1736
    ];
  } else {
    foodPurchasers.value = false;
    nonFoodPurchasers.value = true;
    selectedPurchasers.value = [
        96, 97, 98,
        100, 101, 102, 103, 104, 105, 106, 107, 108, 109,
        1737, 1738
  ];
  }

}
function startFakeProgress() {
  const progressSteps40 = [
    { time: 0,    percent: 0 },
    { time: 4000, percent: 10 },
    { time: 8000, percent: 20 },
    { time: 12000, percent: 25 },
    { time: 16000, percent: 35 },
    { time: 20000, percent: 45 },
    { time: 24000, percent: 55 },
    { time: 28000, percent: 65 },
    { time: 32000, percent: 75 },
    { time: 36000, percent: 80 },
    { time: 38000, percent: 85 },
    { time: 40000, percent: 90 }
  ];
  const progressSteps10 = [
    { time: 0,     percent: 0 },
    { time: 1000,  percent: 10 },
    { time: 2000,  percent: 20 },
    { time: 3000,  percent: 25 },
    { time: 4000,  percent: 35 },
    { time: 5000,  percent: 45 },
    { time: 6000,  percent: 55 },
    { time: 7000,  percent: 65 },
    { time: 8000,  percent: 75 },
    { time: 9000,  percent: 80 },
    { time: 9500,  percent: 85 },
    { time: 10000, percent: 90 }
  ];
  const progressSteps5 = [
    { time: 0,     percent: 0 },
    { time: 500,   percent: 10 },
    { time: 1000,  percent: 20 },
    { time: 1500,  percent: 25 },
    { time: 2000,  percent: 35 },
    { time: 2500,  percent: 45 },
    { time: 3000,  percent: 55 },
    { time: 3500,  percent: 65 },
    { time: 4000,  percent: 75 },
    { time: 4500,  percent: 80 },
    { time: 4750,  percent: 85 },
    { time: 5000,  percent: 90 }
  ];
  const progressSteps70 =[
    { time: 0,     percent: 0 },
    { time: 7000,  percent: 10 },
    { time: 14000, percent: 20 },
    { time: 21000, percent: 25 },
    { time: 28000, percent: 35 },
    { time: 35000, percent: 45 },
    { time: 42000, percent: 55 },
    { time: 49000, percent: 65 },
    { time: 56000, percent: 75 },
    { time: 63000, percent: 80 },
    { time: 66500, percent: 85 },
    { time: 70000, percent: 90 }
  ]
  let choseProgress = [];
  if (foodPurchasers.value) {
    choseProgress = progressSteps70
  }else {
    choseProgress = progressSteps5
  }
  if (!isLoading.value) {
    return;
  }
  choseProgress.forEach(step => {
    setTimeout(() => {
      progress.value = step.percent;
    }, step.time);
  });
}

onMounted(async () => {
  await getPurchasers();

});
function excelExport(event) {
  isLoading.value = true;
  // Verhindert das Standardverhalten des Links (Navigation)
  event.preventDefault();
  if (selectedPurchasers.value.length === 0) {
    if (purchaserId.value !== 0) {
      selectedPurchasers.value =  [purchaserId]
    }
  }

  const url = `/api/v3/excel/selectedPurchasers/${selectedPurchasers.value.join(',')}`;
  // Öffnet die URL in einem neuen Tab
  fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Export fehlgeschlagen');
        }
        return response.blob();
      })
      .then(blob => {
        // Erstelle eine URL für den Blob
        const blobUrl = window.URL.createObjectURL(blob);
        // Erstelle einen Link und simuliere einen Klick
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = 'export.xlsx'; // Dateiname setzen
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl);
        isLoading.value = false;
        progress.value = 100;
        // Hier weißt du, dass der Download fertig ist
      })
      .catch(error => {
        console.error(error);
        isLoading.value = false;
      });
  //window.open(url, '_blank');
  startFakeProgress();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "p-1 w-[150px]" }, "Einkaufsbereich:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((purchaserId).value = $event)),
        class: "outline-0 border border-bg-trader-input-border border-header p-1 w-full shadow-inner-2 text-gray-500"
      }, [
        _cache[5] || (_cache[5] = _createElementVNode("option", { value: 0 }, "Alle Einkaufsbereiche", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(purchasers.value, (purchaser) => {
          return (_openBlock(), _createElementBlock("option", {
            value: purchaser.id,
            key: purchaser.id
          }, _toDisplayString(purchaser.teamIcon) + " " + _toDisplayString(purchaser.name), 9, _hoisted_3))
        }), 128))
      ], 512), [
        [_vModelSelect, purchaserId.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "p-1 h-[300px] w-[150px]" }, "Weitere Auswahl:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPurchasers).value = $event)),
        multiple: "",
        class: "outline-0 border border-bg-trader-input-border border-header gap-2 p-1 w-full shadow-inner-2 text-gray-500"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(purchasers.value, (purchaser) => {
          return (_openBlock(), _createElementBlock("option", {
            class: "p-1",
            value: purchaser.id,
            key: purchaser.id
          }, _toDisplayString(purchaser.teamIcon) + " " + _toDisplayString(purchaser.name), 9, _hoisted_5))
        }), 128))
      ], 512), [
        [_vModelSelect, selectedPurchasers.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "p-2 rounded flex-grow bg-trader-dark-gray",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (selectPurchasers('food')))
      }, "Food Einkaufsbereiche"),
      _createElementVNode("button", {
        class: "p-2 rounded flex-grow bg-trader-dark-gray",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (selectPurchasers('nonFood') ))
      }, "NonFood Einkaufsbereiche")
    ]),
    _createElementVNode("a", {
      onClick: _cache[4] || (_cache[4] = ($event: any) => (excelExport($event))),
      href: "#",
      class: "bg-trader-dark-gray p-2 h-10 w-full rounded hover:bg-trader-blue hover:text-white hover:dark:text-black"
    }, " Abbildungsartikel Export "),
    _createVNode(TRProgress, { progress: progress.value }, null, 8, ["progress"]),
    (progress.value == 100)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Der Abbildungsartikel Export ist fertig"))
      : _createCommentVNode("", true)
  ]))
}
}

})